import { getBodySignatureQueryFunction } from '@/modules/adjusterReportModules/queries/getSignature/getBodySignatureQueryFunction';
import { getInitialVisitSignatureQueryFunction } from '@/modules/adjusterReportModules/queries/getSignature/getInitialVisitSignatureQueryFunction';
import { getPropertyCulpritSignatureQueryFunction } from '@/modules/adjusterReportModules/queries/getSignature/getPropertyCulpritSignatureQueryFunction';
import { getPropertyDamagedSignatureFunction } from '@/modules/adjusterReportModules/queries/getSignature/getPropertyDamagedSignatureQueryFunction';
import { GetSignatureQueryParamsType } from '@/modules/adjusterReportModules/queries/getSignature/getSignatureQuery.type';
import { FileEnType } from '@/modules/adjusterReportModules/types/signatureQueryParams.type';
import { queryOptions } from '@tanstack/react-query';

export const getSignatureQueryOptions = (
  params: GetSignatureQueryParamsType,
  type?: FileEnType,
) => {
  const QueryFn = (params: GetSignatureQueryParamsType) => {
    if (params && type === 'Initial') {
      return getInitialVisitSignatureQueryFunction(params);
    }
    if (params && type === 'PropertyCulprit') {
      return getPropertyCulpritSignatureQueryFunction(params);
    }
    if (params && type === 'PropertyDamaged') {
      return getPropertyDamagedSignatureFunction(params);
    }
    if (params && type === 'Body') {
      return getBodySignatureQueryFunction(params);
    }
  };
  return queryOptions({
    queryKey: [`${type}Signature`, params],
    queryFn: () => QueryFn(params),
    enabled: true,
  });
};
